// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://phstpjvkokwnaeftoqzk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBoc3RwanZrb2t3bmFlZnRvcXprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2ODAwOTIsImV4cCI6MjA1NzI1NjA5Mn0.t3moYESK2nD2kcju-BJ-ayJ6uj7kJL5IxympOkW8GMw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});